export const ITEMS_PER_PAGE = Object.freeze({
  default: [10, 25, 50, 100],
  history: [10, 50, 100],
  quarantine: [10, 50, 100],
});

export default {};
